export default "/images/73d5467367d67b3295abc280e6e5a316.avif";